import { useMemo } from "react";

let base = 1000;
const useId = (prefix?: string) => {
  return useMemo(() => [prefix || "c", ++base].join("-"), [prefix]);
};

export default useId;
